(() => {
  const root = document.querySelector('[data-oven-advisor-root]');
  const cookingRoot = document.querySelector('[data-microwave-advisor]');
  if (!root || !cookingRoot) return;

  const staticOvenPanel = cookingRoot.querySelector('[data-advisor-panel="oven"]');
  const categoryButtons = [...cookingRoot.querySelectorAll('[data-advisor-category]')];
  const heroLead = cookingRoot.querySelector('.pw-microwave-advisor__lead');
  const heroNote = cookingRoot.querySelector('.pw-microwave-advisor__hero-note span');

  const leadCopy = {
    magnetron: 'Voor magnetrons vergelijkt de adviseur plaatsing, techniek, nishoogte, inhoud en gebruikswensen met het actuele assortiment.',
    oven: 'Voor inbouwovens vergelijkt de adviseur nishoogte, ovenbreedte, uitvoering, inhoud en gebruikswensen met het actuele assortiment.',
    kookplaat: 'Bij een kookplaat zijn de werkbladuitsparing, kooktechniek, aansluitwaarde en het aantal fasen bepalend.',
    fornuis: 'Bij een fornuis moeten breedte, kooktechniek, gassoort en elektrische aansluiting samen kloppen.'
  };

  const noteCopy = {
    magnetron: 'Bij inbouwapparatuur zijn de nismaat en ventilatieruimte leidend. Meet de nis voordat u bestelt.',
    oven: 'Meet de ovennis op meerdere punten en controleer ook ventilatie, aansluitwaarde en stekkeraansluiting in de installatietekening.',
    kookplaat: 'Controleer de uitsparing in het werkblad en de elektrische aansluiting; de buitenmaat alleen is niet voldoende.',
    fornuis: 'Controleer naast de breedte ook de gassoort of elektrische aansluiting voordat u bestelt.'
  };

  const activeCategory = () => {
    const selected = categoryButtons.find((button) => button.classList.contains('is-active'));
    return selected?.dataset.advisorCategory || new URLSearchParams(window.location.search).get('type') || 'magnetron';
  };

  const syncCategory = (category) => {
    const isOven = category === 'oven';
    root.hidden = !isOven;
    cookingRoot.classList.toggle('is-oven-active', isOven);
    if (staticOvenPanel) staticOvenPanel.hidden = true;
    if (heroLead) heroLead.textContent = leadCopy[category] || leadCopy.magnetron;
    if (heroNote) heroNote.textContent = noteCopy[category] || noteCopy.magnetron;
  };

  categoryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.advisorCategory || 'magnetron';
      syncCategory(category);
      if (category === 'oven') {
        requestAnimationFrame(() => root.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }
    });
  });

  syncCategory(activeCategory());

  const normalize = (value) => String(value || '').trim().toLowerCase();
  const numberFrom = (value) => {
    const match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  };
  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const form = root.querySelector('[data-oven-form]');
  const quiz = root.querySelector('[data-oven-quiz]');
  const results = root.querySelector('[data-oven-results]');
  const grid = root.querySelector('[data-oven-result-grid]');
  const summary = root.querySelector('[data-oven-result-summary]');
  const noResults = root.querySelector('[data-oven-no-results]');
  const nextButton = root.querySelector('[data-oven-next]');
  const backButton = root.querySelector('[data-oven-back]');
  const submitButton = root.querySelector('[data-oven-submit]');
  const restartButton = root.querySelector('[data-oven-restart]');
  const validation = root.querySelector('[data-oven-validation]');
  const progressLabel = root.querySelector('[data-oven-progress-label]');
  const progressBar = root.querySelector('[data-oven-progress-bar]');
  const steps = [...root.querySelectorAll('[data-oven-step]')];
  const productData = root.querySelector('[data-oven-products]');
  let currentStep = 1;
  let products = [];

  try {
    products = JSON.parse(productData?.textContent || '[]');
  } catch (error) {
    console.error('Ovenadviseur: productgegevens konden niet worden gelezen.', error);
  }

  if (!form || !steps.length) return;

  const showStep = (stepNumber) => {
    currentStep = Math.max(1, Math.min(steps.length, stepNumber));
    steps.forEach((step) => {
      const active = Number(step.dataset.ovenStep) === currentStep;
      step.hidden = !active;
      step.classList.toggle('is-active', active);
    });
    if (progressLabel) progressLabel.textContent = `Stap ${currentStep} van ${steps.length}`;
    if (progressBar) progressBar.style.width = `${(currentStep / steps.length) * 100}%`;
    if (backButton) backButton.hidden = currentStep === 1;
    if (nextButton) nextButton.hidden = currentStep === steps.length;
    if (submitButton) submitButton.hidden = currentStep !== steps.length;
    if (validation) validation.hidden = true;
  };

  const stepIsValid = () => {
    const current = steps[currentStep - 1];
    const radios = [...current.querySelectorAll('input[type="radio"]')];
    return !radios.length || radios.some((input) => input.checked);
  };

  nextButton?.addEventListener('click', () => {
    if (!stepIsValid()) {
      if (validation) validation.hidden = false;
      return;
    }
    showStep(currentStep + 1);
  });

  backButton?.addEventListener('click', () => showStep(currentStep - 1));

  const ovenWidth = (product) => {
    const millimetres = numberFrom(product.widthMm);
    if (millimetres) return millimetres;
    const legacy = numberFrom(product.widthLegacy);
    if (!legacy) return 0;
    return legacy > 150 ? legacy : legacy * 10;
  };

  const canonicalTechnique = (product) => {
    const source = normalize(`${product.technique} ${product.possibilities} ${product.features} ${product.title}`);
    if (source.includes('magnetron') || source.includes('combi-oven') || source.includes('combi oven')) return 'microwave';
    if (source.includes('stoom') || source.includes('steam')) return 'steam';
    if (source.includes('convent')) return 'conventional';
    if (source.includes('multifunction') || source.includes('hetelucht') || source.includes('3 in 1') || source.includes('5 in 1')) return 'multifunction';
    return '';
  };

  const techniqueLabel = (technique) => {
    if (technique === 'conventional') return 'Conventionele oven';
    if (technique === 'multifunction') return 'Multifunctionele oven';
    if (technique === 'steam') return 'Oven met stoom';
    if (technique === 'microwave') return 'Oven met magnetron';
    return 'Inbouwoven';
  };

  const capacityRange = (value) => {
    if (value === 'compact') return [0, 50];
    if (value === 'standard') return [51, 75];
    if (value === 'large') return [76, Number.POSITIVE_INFINITY];
    return [0, Number.POSITIVE_INFINITY];
  };

  const scoreProduct = (product, answers) => {
    const niche = numberFrom(product.niche);
    const width = ovenWidth(product);
    const capacity = numberFrom(product.capacity);
    const technique = canonicalTechnique(product);
    const features = normalize(`${product.features} ${product.possibilities}`);
    const controls = normalize(product.controls);
    const reasons = [];
    let score = 0;

    if (answers.niche !== 'unknown') {
      const selectedNiche = Number(answers.niche);
      if (!niche || Math.abs(niche - selectedNiche) > 3) return null;
      score += 45;
      reasons.push(`sluit aan op een ovennis van circa ${selectedNiche} cm`);
    } else if (niche) {
      score += 5;
      reasons.push(`opgegeven nishoogte: circa ${niche} cm`);
    } else {
      reasons.push('exacte nishoogte moet worden gecontroleerd');
    }

    if (answers.width !== 'any') {
      const selectedWidth = Number(answers.width);
      if (!width) {
        score -= 12;
      } else if (selectedWidth === 60 && width >= 550 && width <= 650) {
        score += 30;
        reasons.push('heeft de gebruikelijke breedte van circa 60 cm');
      } else if (selectedWidth === 90 && width >= 800) {
        score += 30;
        reasons.push('is geschikt voor een extra brede ovennis');
      } else {
        return null;
      }
    }

    if (!technique || technique !== answers.technique) return null;
    score += 42;
    reasons.push(`past bij de keuze ${techniqueLabel(technique).toLowerCase()}`);

    const [minCapacity, maxCapacity] = capacityRange(answers.capacity);
    if (answers.capacity !== 'any') {
      if (capacity >= minCapacity && capacity <= maxCapacity) {
        score += 20;
        reasons.push(`${capacity} liter inhoud past bij de gekozen ruimtebehoefte`);
      } else if (capacity) {
        score -= 12;
      }
    }

    if (answers.priority === 'simple') {
      if (controls.includes('draai') || controls.includes('druk')) {
        score += 18;
        reasons.push('heeft een overzichtelijke fysieke bediening');
      } else if (controls) {
        score += 7;
      }
    }

    if (answers.priority === 'cleaning') {
      if (/pyro|katal|clean|hydro|aqua|reinig/.test(features)) {
        score += 20;
        reasons.push('biedt ondersteuning bij het schoonmaken');
      }
    }

    if (answers.priority === 'steam') {
      if (technique === 'steam' || features.includes('stoom')) {
        score += 20;
        reasons.push('heeft een stoomfunctie of stoomondersteuning');
      }
    }

    if (answers.priority === 'comfort') {
      if (/softclose|soft close|touch|home connect|wifi|app/.test(`${features} ${controls}`)) {
        score += 18;
        reasons.push('biedt extra bedienings- of deurcomfort');
      } else if (controls) {
        score += 5;
      }
    }

    if (normalize(product.energy) === 'a+') score += 4;
    if (capacity) score += Math.min(capacity, 100) / 30;

    return {
      ...product,
      score,
      reasons: reasons.slice(0, 4),
      computedTechnique: technique,
      computedWidth: width
    };
  };

  const productCard = (product, index) => {
    const meta = [
      product.niche ? `${numberFrom(product.niche)} cm nis` : '',
      product.computedWidth ? `${Math.round(product.computedWidth / 10)} cm breed` : '',
      techniqueLabel(product.computedTechnique),
      product.capacity ? `${numberFrom(product.capacity)} liter` : '',
      product.energy ? `Energielabel ${product.energy}` : ''
    ].filter(Boolean);

    const image = product.image
      ? `<div class="pw-microwave-advisor__result-image"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="${index > 2 ? 'lazy' : 'eager'}"></div>`
      : '<div class="pw-microwave-advisor__result-image" aria-hidden="true"></div>';

    return `
      <article class="pw-microwave-advisor__result-card">
        ${image}
        <div class="pw-microwave-advisor__result-body">
          <p class="pw-microwave-advisor__result-vendor">${escapeHtml(product.vendor)}</p>
          <h3>${escapeHtml(product.title)}</h3>
          <p class="pw-microwave-advisor__result-price">${escapeHtml(product.priceFormatted)}</p>
          <div class="pw-microwave-advisor__result-meta">
            ${meta.map((item) => `<span>${escapeHtml(item)}</span>`).join('')}
          </div>
          <ul class="pw-microwave-advisor__result-reasons">
            ${product.reasons.map((reason) => `<li>${escapeHtml(reason)}</li>`).join('')}
          </ul>
          <a class="pw-button" href="${escapeHtml(product.url)}">Bekijk deze oven</a>
        </div>
      </article>
    `;
  };

  const renderResults = (answers) => {
    const ranked = products
      .map((product) => scoreProduct(product, answers))
      .filter(Boolean)
      .sort((a, b) => b.score - a.score || numberFrom(a.price) - numberFrom(b.price))
      .slice(0, 6);

    if (grid) grid.innerHTML = ranked.map(productCard).join('');
    if (noResults) noResults.hidden = ranked.length > 0;
    if (summary) {
      const nicheText = answers.niche === 'unknown' ? 'een nog te meten nis' : `een nis van circa ${answers.niche} cm`;
      summary.textContent = ranked.length
        ? `${ranked.length} passende modellen voor ${nicheText} en de uitvoering ${techniqueLabel(answers.technique).toLowerCase()}.`
        : 'Er is geen betrouwbare exacte match gevonden binnen de huidige selectie.';
    }

    if (quiz) quiz.hidden = true;
    if (results) {
      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!stepIsValid()) {
      if (validation) validation.hidden = false;
      return;
    }

    const data = new FormData(form);
    renderResults({
      niche: data.get('niche') || 'unknown',
      width: data.get('width') || 'any',
      technique: data.get('technique') || '',
      capacity: data.get('capacity') || 'any',
      priority: data.get('priority') || ''
    });
  });

  restartButton?.addEventListener('click', () => {
    form.reset();
    showStep(1);
    if (results) results.hidden = true;
    if (quiz) {
      quiz.hidden = false;
      quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  showStep(1);
})();
